module.exports = __webpack_public_path__ + "img/radio-icon-checked-navy.db67e430.svg";